import Fullscreen from './src/fullscreen-combined';
export default Fullscreen;